import { createContext, useContext } from 'react';
import { ContactType } from '../consts';
import { IUserObject } from '../layout';

interface IChatContext {
  userObject: IUserObject;
  conversations: Array<any>;
  selectedConversation: string;
  setSelectedConversation: (_id: string) => void;
  pinnedConversations: Array<any>;
  getConversations: () => void;
  setContactType: (contactType: ContactType) => void;
  updateNameOfConversation: (_id: string, chat_name: string) => void;
}

const ChatContext = createContext<IChatContext | undefined>(undefined);

ChatContext.displayName = 'ChatContext';

export const useChatContext = () => useContext(ChatContext);

export default ChatContext;
